<ng-container *ngIf="categoryOptions$ | async as categoryOptions; else loading">
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.CATEGORIES' | translate }}
    </glxy-label>
    <mat-select [formControl]="categoryOptionControl" multiple required="true">
      <mat-select-trigger>
        <ng-container *ngIf="firstSelectedLabel$ | async as firstLabel">
          {{ firstLabel }}
        </ng-container>
        <span *ngIf="categoryOptionControl.value?.length > 1">
          (+{{ categoryOptionControl.value.length - 1 }}
          {{
            (categoryOptionControl.value?.length === 2
              ? 'AUTOMATIONS.EDITOR.FILTERS.OTHER'
              : 'AUTOMATIONS.EDITOR.FILTERS.OTHERS'
            ) | translate
          }})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let category of categoryOptions" [value]="category.id">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</ng-container>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
